import { useState } from "react";
import { getPostByCep } from "@service/post";
import { popupError, popupSuccess, popupWarning } from "@service/zendesk";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

export interface Posto {
  nome: string;
  contato_endereco: string;
  contato_numero: string | null;
  contato_complemento: string | null;
  contato_bairro: string;
  contato_cidade: string;
  contato_email: string;
  fone: string;
  codigo_posto: string;
  distance: string;
}

export const usePost = () => {
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [posts, setPosts] = useState<Posto[]>([]);
  const [line, setLine] = useState<string>("");

  const handleSearch = async () => {
    if (inputValue === "") return;

    if (line === "") {
      popupWarning("Nenhuma linha informada.", false);
    }

    setLoading(true);

    try {
      const response = await getPostByCep(inputValue.replace("-", ""), line);
      setPosts(response.data.slice(0, 7));
      popupSuccess("Postos encontrados com sucesso", false);
    } catch (err) {
      const error = err as AxiosError;

      if (error.response?.status === 404) {
        popupError("Nenhum posto encontrada", false);
      } else {
        popupError("Erro inesperado. Tente novamente mais tarde.", false);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleInputValue = (value: string) => {
    setInputValue(value);
  };

  const handleLine = (line: string) => {
    setLine(line);
  };

  const backPage = () => {
    navigate("/");
  };

  const formatDistance = (distanceKm: number): string => {
    if (distanceKm < 1) {
      const meters = Math.round(distanceKm * 1000);
      return `${meters} metros`;
    } else {
      return `${distanceKm.toFixed(1)} km`;
    }
  };
  return {
    handleInputValue,
    loading,
    posts,
    backPage,
    formatDistance,
    handleSearch,
    handleLine,
    line,
  };
};
